import React from 'react';
import { NumericFormat } from 'react-number-format';

interface NumberHelperProps {
  value: number;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
}

function NumberHelper({
  value,
  prefix,
  suffix,
  thousandSeparator = true,
  decimalScale = 2,
  fixedDecimalScale = true
}: NumberHelperProps) {
  return (
    <NumericFormat
      value={value}
      displayType={'text'}
      thousandSeparator={thousandSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      prefix={prefix}
      suffix={suffix ? ` ${suffix}` : undefined}
    />
  );
}

export default NumberHelper;
